import React from 'react';
import { FormattedMessage } from 'react-intl';

import { translations } from '@/locale';

import { InstanceProps } from '@/components/Modal';
import Card from '@/components/Card';
import Grid from '@/components/Grid';
import ModalHeader from '@/components/Modal/ModalHeader';
import Typography from '@/components/Typography';
import Icon from '@/components/Icon';

export interface Props extends InstanceProps {
  credits: number;
  onConfirm: () => void;
}

const text = translations.pages.promoCredits.paymentSuccess;

const PaymentSuccessModal = ({ credits, onConfirm, close }: Props) => {
  return (
    <Card className="w-[450px] p-6 mb-10">
      <Grid.Row>
        <Grid.Column className="w-full">
          <ModalHeader close={close} className="mb-8" />

          <div className="flex flex-col items-center">
            <div className="flex items-center justify-center w-[70px] h-[70px] rounded-full border-2 border-solid border-gray-dark mb-6">
              <Icon type="checkmark" className="text-red" size="text-4xl" />
            </div>

            <Typography is="span" type="small-header" className="font-bold mb-">
              <FormattedMessage id={text.title} />
            </Typography>

            <Typography is="span" type="sm" className="text-gray-dark">
              <FormattedMessage id={text.subtitle} />
            </Typography>

            <Typography is="span" type="sm" className="text-black mb-8">
              <FormattedMessage id={text.packageInfo} values={{ credits }} />
            </Typography>

            <Typography is="span" type="sm" className="text-gray-dark mb-10">
              <FormattedMessage id={text.assignInfo} />
            </Typography>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Card>
  );
};

export default PaymentSuccessModal;
